// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tjyT","newExpiryDate":"styles_newExpiryDate__2PCT1","footer":"styles_footer__ZXMJB"};